import { useLayoutStore } from '@src/stores-v2/StoreContext';
import throttle from 'lodash/throttle';
import { useCallback, useRef } from 'react';

export function useTranscriptLayoutResize() {
  const layoutStore = useLayoutStore();
  const {
    transcriptWidth,
    transcriptMinWidth,
    transcriptMaxWidth,
    isDragging,
  } = layoutStore;

  const initialMouseX = useRef<number | null>(null);
  const initialWidth = useRef<number | null>(null);

  const handleMouseMove = useCallback((e: MouseEvent) => {
    if (initialMouseX.current !== null && initialWidth.current !== null) {
      // transcriptWidth is in pixels, so no need to convert to percentage
      const deltaX = e.clientX - initialMouseX.current;
      const updatedWidth = initialWidth.current + deltaX;

      // Clamp width between min and max
      const newWidth = Math.min(
        Math.max(updatedWidth, transcriptMinWidth),
        transcriptMaxWidth,
      );

      layoutStore.setTranscriptWidth(newWidth);
    }
  }, []);

  const throttledHandleMouseMove = useRef(
    throttle((e: MouseEvent) => {
      handleMouseMove(e);
    }, 100),
  ).current;

  const handleMouseDown = useCallback(
    (e: MouseEvent) => {
      initialMouseX.current = e.clientX;
      initialWidth.current = parseFloat(transcriptWidth);
      layoutStore.setIsDragging(true);
    },
    [transcriptWidth],
  );

  const handleMouseUp = useCallback(() => {
    initialMouseX.current = null;
    initialWidth.current = null;
    layoutStore.setIsDragging(false);
  }, []);

  return {
    isDragging,
    handleMouseMove,
    throttledHandleMouseMove,
    handleMouseDown,
    handleMouseUp,
  };
}
